export const getAuthData = () => {
  const authData = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME as string);
  if (!authData) return {};

  try {
    const parsed = JSON.parse(authData);
    return {
      accessToken: parsed.access_token,
      refreshToken: parsed.refresh_token,
      role: parsed.user?.user_metadata?.is_admin ? 'admin' : 'user',
      username: parsed.user?.user_metadata?.name,
      startTime: parsed.amr?.[0]?.timestamp,
      endTime: parsed.expires_at,
      expiresIn: parsed.expires_in,
      modules: parsed.user?.app_metadata?.providers?.join(',') || '',
      districtName: parsed.user?.user_metadata?.district_name,
      districtId: parsed.user?.user_metadata?.district_id,
      email: parsed.user?.email,
    };
  } catch (error) {
    console.error('Error parsing auth data:', error);
    return {};
  }
};

export const getToken = (contentType = 'application/json') => {
  const { accessToken } = getAuthData();

  return {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Authorization: `Bearer ${accessToken}`,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Content-Type': contentType,
  };
};

export const getTokenWithFormData = () => {
  const { accessToken } = getAuthData();

  return {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Authorization: `Bearer ${accessToken}`,
  };
};
